<template>
  <div id="app">

    <Home @start="setStart(false)" v-if="this.event && this.start"></Home>
		<ItemizerSteps @start="setStart(true)" v-if="this.event && !this.start" :event="this.event"></ItemizerSteps>

		<div v-if="!this.event">You have not provided a query parameter for the event. Something like http://your-url?event=12345. <br> A sample event is bf3a2c06-2bcc-4803-bd66-c4742fdb9b6e</div>

  </div>
</template>

<script>
import ItemizerSteps from './components/ItemizerSteps.vue'
import Home from './components/Home.vue'

export default {
  name: 'App',
  components: {
    Home,
		ItemizerSteps
  },
  methods: {
    setStart(state) {
      this.start = state;
    }
  },
  data: function() {
    return {
      event: null,
      start: true
    }
  },
  created: function() {
    // reads the event query parameter from the URL

    const event = new URL(location.href).searchParams.get('event');
    // const event = 'bf3a2c06-2bcc-4803-bd66-c4742fdb9b6e';
    this.event = event;
  }
}
</script>
